import { useTranslation } from "react-i18next";

import { useTenantBranding } from "@/api/queries/branding";

import { buildHighlights } from "./highlights";

/**
 * Org-wide trust signals shown directly under the hero. Sourced from
 * the per-tenant ``landing_facts`` payload so the row reflects what
 * the tenant has actually configured (active materials, shipping
 * countries, Stripe Connect status, region) rather than hardcoded
 * marketing copy. When nothing is configured (e.g. platform default
 * tenant) the row collapses to nothing rather than rendering
 * placeholders.
 */
export function TrustRow(): JSX.Element | null {
  const { t, i18n } = useTranslation("common");
  const branding = useTenantBranding();
  const items = buildHighlights(
    branding.data?.landing_facts,
    t,
    "public",
    i18n.language,
  );

  if (items.length === 0) return null;

  return (
    <ul
      aria-label={t("home.trust.ariaLabel")}
      className="st-trust grid grid-cols-2 gap-x-6 gap-y-3 text-xs text-ink-3 sm:grid-cols-3 md:grid-cols-6"
    >
      {items.map((it) => (
        <li key={it.key} className="flex items-center gap-1.5">
          <span aria-hidden="true" className="text-ink-4">
            {it.icon}
          </span>
          <span>{it.label}</span>
        </li>
      ))}
    </ul>
  );
}
